import {useState} from 'react';
import {saveRequest} from '../ui/save-request';
import {withBuildingScope} from '../ui/building-scope';

const labels:Record<string,string>={'Company document':'Our own business (MYFM)','Portfolio-level document':'Portfolio-wide (not for one building)'};
/** A document with no building is about our own business or applies across the portfolio (owner, 7 Oct 2026). */
export function DocumentScopeControl({documentId,scope,building,onSaved}:{documentId:string;scope:string|null;building:string|undefined;onSaved:()=>Promise<void>}){
 const [busy,setBusy]=useState(false),[message,setMessage]=useState('');
 const next=scope==='Company document'?'portfolio':'company';
 async function move(){
  setBusy(true);setMessage('');
  try{await saveRequest(withBuildingScope(`/api/documents/${documentId}/scope`,building),{method:'POST',body:JSON.stringify({scope:next,expectedScope:scope})});
   setMessage('Saved. The change is recorded in the audit trail.');try{await onSaved();}catch{setMessage('Saved. Reload the document to see it.');}}
  catch(error){setMessage(error instanceof Error?error.message:'The change could not be confirmed. Reload and try again.');}
  finally{setBusy(false);}
 }
 return <section className="panel" aria-label="Document scope"><h2>Not linked to a building</h2>
  <p>This document is filed as <strong>{labels[scope??'']??'not set'}</strong>.</p>
  <button type="button" className="secondary" disabled={busy} onClick={()=>void move()}>{busy?'Saving…':next==='company'?'Mark as our own business (MYFM)':'Mark as portfolio-wide'}</button>
  {message&&<p role="status">{message}</p>}</section>;
}
